// Select the registrations that were paid and then refunded AND still have
// proof of income: a refund sets payment_status to 'Cancelled', and an
// approved receipt (with a URL) is the evidence the money was received.
// Used by the printed Receipt Report to show these attendees in a separate
// "Refunded" section.
export function selectRefundedWithReceipts(registrations, paymentReceipts = []) {
  const approvedRegIds = new Set(
    paymentReceipts
      .filter(r => r.status === 'Approved' && r.receipt_url)
      .map(r => r.registration_id),
  )
  return registrations.filter(
    r => r.payment_status === 'Cancelled' && approvedRegIds.has(r.id),
  )
}
